import React from 'react';
import { Card } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import {Link} from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const Scheda05 = () => {
  const handleDownload = () => {

    const link = document.createElement('a');
    link.href = '/app/assets/pdf/SCHEDA-5_Tabelle.pdf'; 
    link.download = 'SCHEDA-5_Tabelle.pdf';
    link.click();
  };

  return (<>
    <PageHeader
    title="Scheda 05"
    description="SCHEMA SELEZIONE AZIENDALE DEGLI STAKEHOLDER PRINCIPALI"
    className="mb-3"
    >
    </PageHeader>
    
    <Card style={{marginTop:"2%", marginBottom:"2%"}}>
        <Card.Body>
         <Card.Text>
            <p>La selezione aziendale degli stakeholder principali tiene conto della analisi di materialità e strategica precedente (v. Allegato 3) e può essere affinata dopo la terza fase delle valutazioni seguente.</p>
            <p>La proposta base è inizialmente limitata ai 5 Stakeholder evidenziati nella tabella allegata, con la possibilità nel futuro di modifiche o aggiunte di altri Stakeholder</p>
            <p>Questo elenco di stakeholder è correlato a un codice di due caratteri ed è associato ad una delle due categorie previste dalla norma ESRS (COMUNI e FRUITORI) evidenziate nell’allegato 1. La scelta degli stakeholder sottostanti, abbinato ai singoli ambiti selezionati (V. ALLEGATO 6 successivo), viene effettuata selezionando il Si od il No nella tabella seguente.</p>
            <br />    
            <button onClick={handleDownload}>Apri tabella allegata</button>

          </Card.Text>
          <Card.Footer>
              <Link to="/app/metodologia/fase-a">
                <FontAwesomeIcon icon="chevron-left" className="ms-1 fs-11" />&nbsp;&nbsp;&nbsp;
                Torna all'elenco delle schede della fase A EFRAG 
              </Link>
           </Card.Footer>
        </Card.Body>
      </Card>

    </>)
};

export default Scheda05;
